import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const fallbackLng = ['es'];
export const availableLanguages = [
  {
    code: 'es',
    name: 'CHILE',
    country_code: 'CL',
  },
  {
    code: 'en',
    name: 'English',
    country_code: 'US',
  },
  {
    code: 'br',
    name: 'Brazil',
    country_code: 'BR',
  },
];

i18n
  .use(Backend) // load translations using http (default                                               public/assets/locals/en/translations)
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    fallbackLng: 'es', // fallback language is english.

    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    react: {
      useSuspense: false,
      wait: true,
    },
    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
  });

export default i18n;
